import DarkLogo from '../../NavBar/images/DWP-logo-dark.png'
import LightLogo from '../../NavBar/images/DWP-light.png'
import FirstRepairLogo from '../../NavBar/images/FirstRepair-logo.png'
import FirstRepairLogoWhite from '../../NavBar/images/FR_logo_white.png'

import mobileDWPLogo from '../../NavBar/images/DWP_mobile_logo.svg'
import mobileDWPLogoLight from '../../NavBar/images/DWP_mobile_logo_light.svg'
import mobileDWPLogoBlue from '../../NavBar/images/DWP_logo-blue.svg'
import graphicacyLogo from '../images/graphicacy-logo.svg'
import styles from './Footer.module.scss'

interface FooterProps {
  theme?: 'light' | 'dark'
  blueVariant?: boolean
}

export default function Footer({
  theme = 'light',
  blueVariant = false,
}: FooterProps) {
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerLeft}>
        <a href="https://firstrepair.org" className="pl-0">
          <img
            alt="Circles with FirstRepair below"
            className={styles.footerImage}
            src={theme === 'light' ? FirstRepairLogoWhite : FirstRepairLogo}
          />
        </a>
        <a href="https://decolonizingwealth.com" className="pr-4 sm:pl-6">
          <img
            alt="W over squiggly line with Decolonizing Wealth Project to the right"
            className={styles.footerDWImage}
            src={theme === 'light' ? LightLogo : DarkLogo}
          />
          <img
            alt="W over squiggly line"
            src={
              blueVariant
                ? mobileDWPLogoBlue
                : theme === 'light'
                ? mobileDWPLogoLight
                : mobileDWPLogo
            }
            className={styles.footerDWMobileImage}
          />
        </a>
      </div>
      <div className={styles.footerRight}>
        <p className={styles.designedBy}>Designed and built by </p>
        <a href="https://www.graphicacy.com" className={styles.graphicacyLink}>
          <img
            alt="Graphicacy logo"
            className={styles.graphicacyLink}
            src={graphicacyLogo}
          />
        </a>
      </div>
    </div>
  )
}
